import { getDefaultExportFromCjs } from " commonjsHelpers.js";
import { __require as requireMain } from "/Users/jillig/Design/Muletown Digital/Clients/Clay Lady/Clay Lady Website - Local/app/public/wp-content/themes/mtd-theclaylady/source/js/main.js";
var mainExports = requireMain();
export { mainExports as __moduleExports };
export default /*@__PURE__*/getDefaultExportFromCjs(mainExports);